import { render } from "./NavFlag.vue?vue&type=template&id=691aa543"
import script from "./NavFlag.vue?vue&type=script&lang=js"
export * from "./NavFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__